var _a;
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateHooks } from "../generators/generator.hooks";
import { createContactBankAccountStart, getContactBankAccountsStart, removeBankAccountStart, updateBankAccountOwnerNameStart, } from "./bankAccount.actions";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
import { contactBankAccountsFetchError, createContactBankAccountError, getContactBankAccounts, isCreatingContactBankAccount, isFetchingContactBankAccounts, isRemovingBankAccountSelector, isUpdatingBankAccountOwnerNameSelector, removeBankAccountError, updateBankAccountOwnerNameError, } from "./bankAccount.selectors";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), useCount = _a.useCount;
export var useRemoveBankAccount = function () {
    var dispatch = useDispatch();
    var _a = React.useState(), bankAccountId = _a[0], setBankAccountId = _a[1];
    var isRemoving = useSelector(function (state) {
        return isRemovingBankAccountSelector(state, bankAccountId);
    });
    var error = useSelector(function (state) {
        return removeBankAccountError(state, bankAccountId);
    });
    var removeAccount = function (_a) {
        var id = _a.id, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        setBankAccountId(id);
        dispatch(removeBankAccountStart.getAction({ id: id, onSuccess: onSuccess, onFailure: onFailure }));
    };
    return {
        isRemoving: isRemoving,
        error: error,
        removeAccount: removeAccount,
    };
};
export var useUpdateBankAccountOwnerName = function () {
    var dispatch = useDispatch();
    var _a = React.useState(), bankAccountId = _a[0], setBankAccountId = _a[1];
    var isUpdating = useSelector(function (state) {
        return isUpdatingBankAccountOwnerNameSelector(state, bankAccountId);
    });
    var error = useSelector(function (state) {
        return updateBankAccountOwnerNameError(state, bankAccountId);
    });
    var updateOwnerName = function (_a) {
        var id = _a.id, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        setBankAccountId(id);
        dispatch(updateBankAccountOwnerNameStart.getAction({
            id: id,
            data: data,
            onSuccess: onSuccess,
            onFailure: onFailure,
        }));
    };
    return {
        isUpdating: isUpdating,
        error: error,
        updateOwnerName: updateOwnerName,
    };
};
/**
 * The bank accounts of one contact, fetched whenever the contact (or the account
 * it belongs to) changes. Pass neither id - while the user is still loading, for
 * instance - and nothing is fetched.
 */
export var useContactBankAccounts = function (_a) {
    var contactId = _a.contactId, accountId = _a.accountId;
    var dispatch = useDispatch();
    var bankAccounts = useSelector(function (state) {
        return getContactBankAccounts(state, { contactId: contactId, accountId: accountId });
    });
    var isFetching = useSelector(function (state) {
        return isFetchingContactBankAccounts(state, { contactId: contactId, accountId: accountId });
    });
    var fetchError = useSelector(function (state) {
        return contactBankAccountsFetchError(state, { contactId: contactId, accountId: accountId });
    });
    var refetch = function () {
        if (contactId == null && accountId == null) {
            return;
        }
        dispatch(getContactBankAccountsStart.getAction({ contactId: contactId, accountId: accountId }));
    };
    React.useEffect(function () {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactId, accountId]);
    return { bankAccounts: bankAccounts, isFetching: isFetching, fetchError: fetchError, refetch: refetch };
};
export var useCreateContactBankAccount = function () {
    var dispatch = useDispatch();
    var isCreating = useSelector(isCreatingContactBankAccount);
    var error = useSelector(createContactBankAccountError);
    var createBankAccount = function (_a) {
        var contactId = _a.contactId, accountId = _a.accountId, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        dispatch(createContactBankAccountStart.getAction({
            contactId: contactId,
            accountId: accountId,
            data: data,
            onSuccess: onSuccess,
            onFailure: onFailure,
        }));
    };
    return { isCreating: isCreating, error: error, createBankAccount: createBankAccount };
};
